/**
 * @generated SignedSource<<82f707f5e1900b63ef6d27065ff30e56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type queryAgentMentionsFragment$data = {
  readonly id: string;
  readonly identityAccount: {
    readonly picture: AGG$URL;
  } | null;
  readonly identityAccountId: string | null;
  readonly name: string | null;
  readonly " $fragmentType": "queryAgentMentionsFragment";
};
export type queryAgentMentionsFragment$key = {
  readonly " $data"?: queryAgentMentionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"queryAgentMentionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "queryAgentMentionsFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "LinkedField",
      "name": "identityAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "identityAccountId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "AgentStudioAssistant"
};

(node as any).hash = "e8b4ce6a6bbc22c76e7da2a2f720ab58";

export default node;
